import { useEffect, useState } from "react";

/** Counts down from `durationSeconds` to zero, then restarts automatically. */
export function useCountdown(durationSeconds: number) {
  const [remaining, setRemaining] = useState(durationSeconds);

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? durationSeconds : prev - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, [durationSeconds]);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;

  return { hours, minutes, seconds };
}
